import { render, staticRenderFns } from "./activityRates.vue?vue&type=template&id=958f1152&scoped=true"
import script from "./activityRates.vue?vue&type=script&lang=js"
export * from "./activityRates.vue?vue&type=script&lang=js"
import style0 from "./activityRates.vue?vue&type=style&index=0&id=958f1152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958f1152",
  null
  
)

export default component.exports